import { renderReact } from "hypernova-react";
import BurgerMenu from "web/react/components/burger-menu/burger-menu";
import CookieBannerVariation from "web/react/components/cookie-banner/cookie-banner-variation";
import DesignerExitTrigger from "web/react/components/designer-exit-trigger/designer-exit-trigger";
import EmailCaptureOverlay from "web/react/components/email-capture-overlay/email-capture-overlay";
import FBProductLandingOverlay from "web/react/components/fb-product-landing-overlay/fb-product-landing-overlay";
import FollowStickyBanner from "web/react/components/follow-sticky-banner/follow-sticky-banner";
import Hint from "web/react/components/hint/hint";
import ProductArea from "web/react/components/product-area/product-area";
import ProductGallery from "web/react/components/product-gallery/product-gallery";
import RecentlyViewedEmailCapture from "web/react/components/recently-viewed-email-capture/recently-viewed-email-capture";
import RelatedProductsRails from "web/react/components/related-products-rails/related-products-rails";
import RelatedSearchesRail from "web/react/components/related-searches-rail/related-searches-rail";
import SearchButton from "web/react/components/search-button/search-button";
import ProductPage from "web/react/pages/product/in-stock/in-stock";
import OOSProductPage from "web/react/pages/product/out-of-stock/out-of-stock";
import withRedux from "web/react/redux-provider";


export function initialiseReact() {
    renderReact("BurgerMenu.jsx", BurgerMenu);
    renderReact("CookieBannerVariation.jsx", CookieBannerVariation);
    renderReact("DesignerExitTrigger.jsx", DesignerExitTrigger);
    renderReact("EmailCaptureOverlay.jsx", EmailCaptureOverlay);
    renderReact("FBProductLandingOverlay.jsx", FBProductLandingOverlay);
    renderReact("FollowStickyBanner.jsx", FollowStickyBanner);
    renderReact("Hint.jsx", Hint);
    renderReact("OOSProductPage.jsx", OOSProductPage);
    renderReact("ProductArea.jsx", withRedux(ProductArea));
    renderReact("ProductGallery.jsx", ProductGallery);
    renderReact("ProductPage.jsx", ProductPage);
    renderReact("RecentlyViewedEmailCapture.jsx", RecentlyViewedEmailCapture);
    renderReact("RelatedProductsRails.jsx", RelatedProductsRails);
    renderReact("SearchButton.jsx", SearchButton);
    renderReact("RelatedSearchesRail.jsx", RelatedSearchesRail);
}
